import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import templateContent from "./set-sample-request-lab-codes-modal.html";

import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import sampleRequestManager from "../../controllers/sampleRequestManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class SetSampleRequestLabCodesModalComponent extends Component {
	constructor () {
		super("setSampleRequestLabCodesModalComponent");

		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (this.get("open")) {
			this.open();
		}
	}

	close () {
		Shark.set({
			currNotComplianceReport: null
		});

		this.set({
			open: false,
		});
		$(`#setSampleRequestLabCodesModal`).modal("hide");
	}
	
	init () {
		this.addComponents([informationModalComponent, waitBoxComponent]);
	}

	open () {
		$(`#setSampleRequestLabCodesModal`).modal("show");
		this.set({
			open: true,
		});
	}

	setSampleRequestLabCode (sampleRequest) {
		console.log(sampleRequest);
		Shark.set({
			currSampleRequest: sampleRequest
		});
		Shark.render();
		this.open();
	}

	setSampleRequestLabCodesBtn_clickHandler (event, data) {
		const { sampleRequestList } = Shark.get();
		const currSampleRequest = Utils.safp(sampleRequestList, "guid", data.guid);

		if (currSampleRequest) {
			this.setSampleRequestLabCode(currSampleRequest);
		}
	}

	setSampleRequestLabCodesModalAddCodeBtn_clickHandler () {
		const { currSampleRequest } = Shark.get();

		if (currSampleRequest) {
			currSampleRequest.addLabCode();
			Shark.render();
		}
	}

	setSampleRequestLabCodesModalCancelBtn_clickHandler () {
		const { currSampleRequest } = Shark.get();
		
		if (currSampleRequest) {
			currSampleRequest.restore();
		}

		this.close();
	}

	setSampleRequestLabCodesModalConfirmBtn_clickHandler () {
		const { currSampleRequest } = Shark.get();
		
		if (currSampleRequest) {
			waitBoxComponent.open();

			sampleRequestManager.setLabCodes(currSampleRequest)
			.then(() => {
				this.close();
				waitBoxComponent.close();

				if (Shark.activePage.refreshList) {
					Shark.activePage.refreshList();
				}
				else {
					Shark.render();
				}
			});
		}
	}

	setSampleRequestLabCodesModalDeleteCodeBtn_clickHandler (event, data) {
		const { currSampleRequest } = Shark.get();

		if (currSampleRequest) {
			currSampleRequest.deleteLabCode(data.index);
			Shark.render();
		}
	}
}

const setSampleRequestLabCodesModalComponent = new SetSampleRequestLabCodesModalComponent();

Shark.registerComponent(setSampleRequestLabCodesModalComponent);

export default setSampleRequestLabCodesModalComponent;
